export default __webpack_public_path__ + "../img/6cdc78f3f09116a7a2d817ed377c14b4.png";